import { CONTENT_KEY_INTERPOSER, CONTENT_KEY_PACKAGE } from "./contentHelper";
const PinTableColumns = [
  {
    title: 'Group',
    dataIndex: 'group',
    width: '10%',
  },
  {
    title: 'Signal',
    dataIndex: 'signal',
    width: '25%',
    sorter: (a, b) => a.signal.localeCompare(b.signal)
  }, {
    title: 'Component - Pin',
    dataIndex: 'pin',
    width: '15%'
  },
  {
    title: 'Usage',
    dataIndex: 'usage',
    width: '10%',
  },
  {
    title: 'Model',
    dataIndex: 'model',
    width: '15%'
  }, {
    title: 'Stimulus',
    dataIndex: 'inputStimulus',
    width: '15%',
  }, {
    title: 'Corner',
    dataIndex: 'corner',
    width: '10%'
  }];

const signalSortConfig = {
  // TX
  'TXDATA': 1,
  'TXVLD': 2,
  'TXTRK': 3,
  'TXCKP': 4,
  'TXCKN': 5,
  'TXCKRD': 6,
  'TXDATARD': 7,
  'TXVLDRD': 8,
  'TXDATASB': 9,
  'TXCKSB': 10,
  'TXDATASBRD': 11,
  'TXCKSBRD': 12,

  // RX
  'RXDATA': 13,
  'RXVLD': 14,
  'RXTRK': 15,
  'RXCKP': 16,
  'RXCKN': 17,
  'RXCKRD': 18,
  'RXDATARD': 19,
  'RXVLDRD': 20,
  'RXDATASB': 21,
  'RXCKSB': 22,
  'RXDATASBRD': 23,
  'RXCKSBRD': 24,

  // power
  'VSS': 25,
  'VCCIO': 26,
  'VCCFWDIO': 27,
  'VCCAON': 28
};

function getD2dSetupTableData(content, preSignals) {
  // d2d table data;
  const Types = ['BGA', 'DIE'];
  let dataList = [];
  if (!content) { return dataList }
  let keys = Object.keys(content);
  keys = keys.filter(item => [CONTENT_KEY_INTERPOSER, CONTENT_KEY_PACKAGE].includes(item));
  for (let key of keys) {
    const { Components, Signals } = content[key];
    const ICComps = Components.filter(item => Types.includes(item.type));
    for (let signalInfo of Signals) {
      const { nets, name, group, signalType, displayName } = signalInfo;
      const findIndex = dataList.findIndex(item => item.signal === name && item.group === group);

      let pinList = [];
      for (let comp of ICComps) {
        const filterPins = comp.pins.filter(item => item.signal === name);
        let info = [];
        if (filterPins.length) {
          info = filterPins.map(item => {
            return {
              component: comp.name,
              pin: item.pin,
              net: item.net,
              signal: item.signal,
              type: comp.type,
              signalNets: nets || [],
            }
          })
        }
        pinList.push(...info)
      }

      const info = {
        signalNets: nets,
        pinList,
        key
      }
      if (findIndex < 0) {
        dataList.push({
          signal: name,
          [key]: info,
          group: group,
          signalType,
          displayName
        })

      } else {
        dataList[findIndex][key] = info;
      }
    }
  }
  // dataList = calculateGroupLengths(dataList);
  dataList = groupDataByGroupAndType(dataList);
  return dataList
}

function compressSignalRanges(signalNames) {
  if (!signalNames || signalNames.length === 0) {
    return [];
  }
  const parsedSignals = signalNames.map(name => {
    let match = null;
    match = name.match(/^(.*?)\[(\d+)\]$/);
    if (!match) {
      match = name.match(/^(.*)_(\d+)$/);
    }
    if (!match) {
      match = name.match(/^(.*?)(\d+)$/);
    }
    if (match) {
      return {
        baseName: match[1],
        index: parseInt(match[2], 10),
        originalName: name
      };
    }
    return null;
  }).filter(s => s !== null);
  if (parsedSignals.length === 0) {
    return signalNames.length > 0 ? signalNames : [];
  }
  parsedSignals.sort((a, b) => b.index - a.index);
  if (parsedSignals.length === 0) {
    return [];
  }
  const baseName = parsedSignals[0].baseName;
  if (parsedSignals.some(s => s.baseName !== baseName)) {
    return signalNames;
  }
  const compressedRanges = [];
  let currentHigh = parsedSignals[0].index;
  let currentLow = parsedSignals[0].index;
  for (let i = 1; i < parsedSignals.length; i++) {
    const currentIndex = parsedSignals[i].index;
    const previousIndex = parsedSignals[i - 1].index;
    if (currentIndex === previousIndex - 1) {
      currentLow = currentIndex;
    } else {
      const compressName = currentHigh === currentLow ? `${baseName}[${currentHigh}]` : `${baseName}[${currentHigh}:${currentLow}]`
      compressedRanges.push(compressName);
      currentHigh = currentIndex;
      currentLow = currentIndex;
    }
  }
  const compressName = currentHigh === currentLow ? `${baseName}[${currentHigh}]` : `${baseName}[${currentHigh}:${currentLow}]`
  compressedRanges.push(compressName)

  return compressedRanges;
}

function assignGroupColorIndex(data) {
  const groupIndexMap = new Map();
  let groupCount = 0;
  for (const item of data) {
    if (!groupIndexMap.has(item.group)) {
      groupIndexMap.set(item.group, groupCount % 2);
      groupCount++;
    }
  }
  const indexedData = data.map(leaderNode => {
    const groupLength = groupIndexMap.get(leaderNode.group);
    const newLeaderNode = {
      ...leaderNode,
      groupLength: groupLength
    };
    if (newLeaderNode.originalChildren) {
      newLeaderNode.originalChildren = newLeaderNode.originalChildren.map(child => ({
        ...child,
        groupLength: groupLength
      }));
    }
    return newLeaderNode;
  });

  return indexedData;
}

function groupDataByGroupAndType(data) {
  const combinationMap = new Map();
  data.forEach((item, index) => {
    const { group, signalType } = item;
    const key = `${group}_${signalType}`;
    if (!combinationMap.has(key)) {
      combinationMap.set(key, {
        group: group,
        signalType: signalType,
        key: key,
        children: []
      });
    }
    const leaderNode = combinationMap.get(key);
    leaderNode.children.push({
      ...item,
      key: `${key}-child-${index}`
    });
    const children = leaderNode.children;
    if (children.length > 1) {
      const ifSameName = children[0].displayName === children[children.length - 1].displayName;
      leaderNode.displayName = ifSameName ? children[0].displayName : `${children[0].displayName} - ${children[children.length - 1].displayName}`;
    } else if (children.length === 1) {
      leaderNode.displayName = children[0].displayName;
    }
  });
  let groupData = Array.from(combinationMap.values());
  groupData = groupData.map(data => {
    if (data.children && data.children.length === 1) {
      data = {
        ...data,
        ...data.children[0]
      }
      delete data.children;
    }
    return data
  })
  groupData = assignGroupColorIndex(groupData);
  groupData = calculateRowSpanAndGroup(groupData);
  return groupData;
}

function calculateRowSpanAndGroup(rawList) {
  const processedList = [];
  let groupIndexMap = new Map();
  let groupColorCount = 0;

  for (let i = 0; i < rawList.length; i++) {
    const currentItem = rawList[i];
    let span = 1;
    if (i === 0 || rawList[i - 1].group !== currentItem.group) {
      for (let j = i + 1; j < rawList.length; j++) {
        if (rawList[j].group === currentItem.group) {
          span++;
        } else {
          break;
        }
      }
    } else {
      span = 0;
    }
    let groupLength = 0;
    if (!groupIndexMap.has(currentItem.group)) {
      groupLength = groupColorCount % 2;
      groupIndexMap.set(currentItem.group, groupLength);
      groupColorCount++;
    } else {
      groupLength = groupIndexMap.get(currentItem.group);
    }
    const leaderNode = {
      ...currentItem,
      rowSpan: span,
      groupLength: groupLength
    };
    if (leaderNode.children) {
      leaderNode.children = leaderNode.children.map(child => ({
        ...child,
        groupLength: groupLength
      }));
    }
    processedList.push(leaderNode);
  }
  processedList.forEach(data => {
    if (data.children) {
      const numberRegex = /\[(\d+)\]/;
      data.children.sort((a, b) => {
        const matchA = a.signal.match(numberRegex);
        const numA = matchA ? parseInt(matchA[1], 10) : -1;
        const matchB = b.signal.match(numberRegex);
        const numB = matchB ? parseInt(matchB[1], 10) : -1;
        return numA - numB;
      });
      if (data.children.length > 1) {
        const ifSameName = data.children[0].displayName === data.children[data.children.length - 1].displayName;
        data.displayName = ifSameName ? data.children[0].displayName : `${data.children[0].displayName} - ${data.children[data.children.length - 1].displayName}`;
      } else if (data.children.length === 1) {
        data.displayName = data.children[0].displayName;
      }
    }
  })
  return processedList;
}

function getBaseSignalName(signalName) {
  const match = signalName.match(/(TX|RX)/i);
  if (match) {
    const index = match.index;
    return signalName.substring(index);
  }
  return signalName;
};

function getSignalPrefix(signalName) {
  const baseName = getBaseSignalName(signalName);
  const prefix = signalName.replace(baseName, '');
  return prefix.replace(/[_\]]+$/, '');
};

function getSignalGroup(signalName) {
  const baseName = getBaseSignalName(signalName);
  const prefix = getSignalPrefix(signalName);
  if (baseName.includes('TX')) {
    return `${prefix}_TX`;
  } else if (baseName.includes('RX')) {
    return `${prefix}_RX`;
  } else if (baseName.includes('VCC') || baseName === 'VSS') {
    return `${prefix}_POWER`;
  } else {
    return prefix ? `${prefix}_OTHER` : 'OTHER';
  }
};

function getBusIndex(signalName) {
  const match = signalName.match(/\[(\d+)\]/);
  return match ? parseInt(match[1]) : -1;
};

function getSignalPriority(signalName) {
  const baseName = getBaseSignalName(signalName);
  const busBaseName = baseName.replace(/\[\d+\]/, '');
  return signalSortConfig[busBaseName] || signalSortConfig[baseName] || 999;
};

function doPinsGroupBySignal(interfaceData, index) {
  if (!interfaceData.content || !interfaceData.content.length) {
    return interfaceData;
  }
  const signal = interfaceData.content[0];
  const signalName = signal.name;
  const group = signal.group;
  const enhancedInterface = {
    ...interfaceData,
    interfaceKey: `interposer-${index}`
  };
  enhancedInterface.content = [{
    ...signal,
    group: group || getSignalGroup(signalName),
    baseSignalName: getBaseSignalName(signalName)
  }];
  enhancedInterface.group = group || getSignalGroup(signalName);
  enhancedInterface.sortPriority = getSignalPriority(signalName);
  enhancedInterface.busIndex = getBusIndex(signalName);
  return enhancedInterface;
};

function getAllChildrenPins(row, type, componentName) {
  if (!row || !row.children || row.children.length === 0) {
    return [];
  }
  const allChildrenPins = [];
  row.children.forEach(child => {
    const pinList = child[type] && child[type].pinList ? child[type].pinList : [];
    const pinInfo = pinList.find(item => item.component === componentName);
    if (pinInfo) {
      allChildrenPins.push(pinInfo);
    }
  });
  const pins = allChildrenPins ? allChildrenPins.map(item => item.pin) : [];
  return pins;
}

export {
  PinTableColumns,
  getD2dSetupTableData,
  compressSignalRanges,
  groupDataByGroupAndType,
  getAllChildrenPins,
  doPinsGroupBySignal
}